import { BRUSH_SIZES, TOOLS } from "../../constants/editor";
import type { ToolId } from "../../shared/game";

type ToolPickerProps = {
  activeTool: ToolId;
  onSelect: (tool: ToolId) => void;
  brushSize: number;
  onBrushSizeChange: (size: number) => void;
};

export function ToolPicker({ activeTool, onSelect, brushSize, onBrushSizeChange }: ToolPickerProps) {
  return (
    <div style={{ display: "grid", gap: 8 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 6 }}>
        {TOOLS.map((tool) => (
          <button
            key={tool.id}
            type="button"
            onClick={() => onSelect(tool.id)}
            className={activeTool === tool.id ? "active-button" : "ghost-button"}
            style={{ display: "grid", justifyItems: "center", gap: 4, padding: "8px 6px", minHeight: 52 }}
          >
            <span style={{ fontSize: 15 }}>{tool.icon}</span>
            <span style={{ fontSize: 11 }}>{tool.label}</span>
          </button>
        ))}
      </div>

      {(activeTool === "ink" || activeTool === "erase") && (
        <div style={{ display: "flex", gap: 6 }}>
          {BRUSH_SIZES.map((size) => (
            <button
              key={size}
              type="button"
              onClick={() => onBrushSizeChange(size)}
              className={brushSize === size ? "active-button" : "ghost-button"}
              style={{ flex: 1, padding: "6px 6px", minHeight: 36 }}
            >
              {size}x
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
